import { initializeApp } from "@firebase/app";
import { getAuth } from "@firebase/auth";
import { getFirestore } from "@firebase/firestore";
import { getStorage } from '@firebase/storage';

// import { initializeApp } from 'firebase-admin/app';

// import admin from 'firebase-admin';
// import functions from 'firebase-functions';

const firebaseConfig = {
      apiKey: "AIzaSyBVhAnOp0_29YMhn5pL-JfPw0Tx7FrLTb0",
      authDomain: "portfolio-c4a93.firebaseapp.com",
      databaseURL: "https://portfolio-c4a93.firebaseio.com",
      projectId: "portfolio-c4a93",
      storageBucket: "portfolio-c4a93.appspot.com",
      messagingSenderId: "315295652774",
      appId: "1:315295652774:web:a2e4e789544178f8e2cd67",
      measurementId: "G-E9EFE5PNNW"
};


const firebaseConfigtest = {
      apiKey: "AIzaSyAZBPmZcitrg8Dw8DMUkwuqB1JRcbJj-6I",
      authDomain: "rockpaperscissors-b19ba.firebaseapp.com",
      databaseURL: "https://rockpaperscissors-b19ba.firebaseio.com",
      projectId: "rockpaperscissors-b19ba",
      storageBucket: "rockpaperscissors-b19ba.appspot.com",
      messagingSenderId: "328081556370",
      appId: "1:328081556370:web:55bd1442c5d131e32bb74b",
      measurementId: "G-T56Q3LPWXC"
};


//should say     firebaseConfig     before eas build. Should say    firebaseConfigdev   during development. In other words "dev" should be added/taken away.

const app = initializeApp(firebaseConfig);
const authe = getAuth(app);
const firebase = getFirestore(app);
const imageDb = getStorage(app)


//       admin.initializeApp(functions.firebaseConfig.firebase);

// const db = admin.firestore();

export {
      authe,
      firebase,
      imageDb,
      firebaseConfig
      // db
}